import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Card } from '../../shared/components';
import { api } from '../../utils/api';
import UnitTestRunner from './UnitTestRunner';
import './CollegeAlgebra.css';

export default function Test() {
  const { slug } = useParams();
  const [unit, setUnit] = useState(null);
  const [error, setError] = useState('');
  const [started, setStarted] = useState(false);

  useEffect(() => {
    api
      .get(`/api/college-algebra/units/${slug}`)
      .then((data) => setUnit(data.unit))
      .catch(() => setError('Unable to load this unit right now.'));
  }, [slug]);

  if (started) {
    return <UnitTestRunner unitSlug={slug} onExit={() => setStarted(false)} />;
  }

  if (error) return <p className="ca-error">{error}</p>;
  if (!unit) return <p>Loading&hellip;</p>;

  return (
    <div className="ca-page">
      <Link to={`/college-algebra/units/${slug}`} className="ca-back-link">&larr; Back to {unit.name}</Link>
      <h1>{unit.name} &mdash; Unit Test</h1>
      <Card>
        <p>
          A timed, fixed-length test covering every concept in this unit, sampled evenly across each one. Unlike
          the practice quiz, this is graded pass/fail so you can tell when you're ready to move on.
        </p>
        <ul>
          <li>16 questions, spread evenly across the unit's concepts</li>
          <li>About 24 minutes, timed</li>
          <li>70% or higher passes</li>
        </ul>
        <Button onClick={() => setStarted(true)}>Start unit test</Button>
      </Card>
    </div>
  );
}
